import { contrastRatio } from '@yola/yola-palette-generator';
import increaseColorPointByRatio from '../../../../../common/utils/increase-color-point-by-ratio';
import increaseOpacity from '../../../../../common/utils/increase-opacity';

const light = (params) => {
  const { targetColor, backgroundColor, targetColorPalette, whiteColor } = params;
  const fallback = {
    rule: 'secondaryButton.greyBorder.border.default.light',
    params,
  };
  if (contrastRatio(backgroundColor, targetColor) !== 1) {
    return increaseColorPointByRatio({
      targetColor,
      backgroundColor: whiteColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.1,
      fallback,
    });
  }

  if (contrastRatio(targetColor, whiteColor) < 1.1) {
    return increaseColorPointByRatio({
      targetColor,
      backgroundColor: targetColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.1,
      fallback,
    });
  }

  return increaseOpacity({
    targetColor: whiteColor,
    backgroundColor: targetColor,
    opacity: 0.01,
    condition: (ratio) => ratio >= 1.1,
    fallback,
  });
};

export default light;
